webpackJsonp([10991734084388],{

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SEO = __webpack_require__(9);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _gatsbyImage = __webpack_require__(75);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _indexModule = __webpack_require__(327);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setHtml($html) {
	  return { __html: $html };
	}
	
	var About = function About(_ref) {
	  var data = _ref.data,
	      transition = _ref.transition;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      { style: { textAlign: 'center' } },
	      'About'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: transition && transition.style },
	      _react2.default.createElement(_SEO2.default, { slug: 'About' }),
	      _react2.default.createElement(
	        'div',
	        { style: { padding: '24px' } },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.about.childImageSharp.sizes })
	      ),
	      _react2.default.createElement('div', {
	        className: _indexModule2.default.inner,
	        dangerouslySetInnerHTML: setHtml(data.allMarkdownRemark.edges['0'].node.html)
	      })
	    )
	  );
	};
	
	exports.default = About;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"inner":"src-pages-about----index-module---inner---2FmvY"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-index-js-45ad63c07ede72262488.js